import React from 'react';
import { Switch } from 'react-router-dom';
import AuthRoute from './AuthRoute';


import vendorCandidates from "../../../pages/vendor/Candidates";
import vendorRequirements from "../../../pages/vendor/Requirements";
import vendorNew from "../../../pages/vendor/dashboard/New";
import vendorSTC from "../../../pages/vendor/dashboard/Stc";
import vendorDocumentColleted from "../../../pages/vendor/dashboard/DocumentColleted";
import vendorFinalInterviewScheduled from "../../../pages/vendor/dashboard/FinalInterviewScheduled";
import vendorFinalInterviewCompleted from "../../../pages/vendor/dashboard/FinalInterviewCompleted";
import vendorInterviewScheduled from "../../../pages/vendor/dashboard/InterviewScheduled";
import vendorScheduleInterview from "../../../pages/vendor/dashboard/ScheduleInterview";
import vendorJoined from "../../../pages/vendor/dashboard/Joined";
import vendorOffered from "../../../pages/vendor/dashboard/Offered";
import vendorOfferedDeclined from "../../../pages/vendor/dashboard/OfferedDeclined";
import vendorSalaryBreakup from "../../../pages/vendor/dashboard/SalaryBreakup";
import vendorYetToJoin from "../../../pages/vendor/dashboard/YetToJoin";


import RecCoinWidrawPage from "../../Header/RecCoinWidrawPage";
import ClaimCoins from "../../../pages/vendor/ClaimCoins";
import VendorInvoice from "../../../pages/vendor/VendorInvoice";
import RecCoinHistory from "../../../pages/vendor/RecCoinHistory";
import DisclosureAgreement from "../../../pages/vendor/VendorDisclosureAgreement";

import Search from "../../../pages/recruiter/Search";
import Dashboard from "../../../pages/dashboard";
import ParsedResume from "../../Candidates/ParsedResume";
import DuplicateCheckCandidates from '../../../pages/vendor/DuplicateCheckCandidates';
import CheckedCandidateList from '../../../pages/vendor/CheckedCandidateList';

const VendorRoutes = ({ role }) => {
  return (
    <Switch>
      <AuthRoute path="/app/search" role={role} roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR", "FREELANCER", "SUBVENDOR","SUBCONTRACT"]} component={Search} />
      <AuthRoute path="/app/dashboard" role={role} roles={["SUPERADMIN", "ADMIN", "RECRUITER", "CLIENTCOORDINATOR", "FREELANCER", "SUBVENDOR","SUBCONTRACT"]} component={Dashboard} />
      <AuthRoute path="/app/check_duplicates" role={role} roles={["SUPERADMIN", "ADMIN", "RECRUITER", "CLIENTCOORDINATOR", "FREELANCER", "SUBVENDOR","SUBCONTRACT"]} component={DuplicateCheckCandidates} />
      <AuthRoute path="/app/checking_candidates" role={role} roles={["SUPERADMIN", "ADMIN", "RECRUITER", "CLIENTCOORDINATOR", "FREELANCER", "SUBVENDOR","SUBCONTRACT"]} component={CheckedCandidateList} />
      <AuthRoute path="/app/parsed_resume" role={role} roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR", "FREELANCER", "SUBVENDOR","SUBCONTRACT"]} component={ParsedResume} />



      <AuthRoute path="/app/non-disclosure-agreement" role={role} roles={["SUBCONTRACT"]} component={DisclosureAgreement} />
      <AuthRoute path="/app/raise_invoice" role={role} roles={["SUBCONTRACT"]} component={ClaimCoins} />
      <AuthRoute path="/app/vendor_invoice" role={role} roles={["SUBCONTRACT"]} component={VendorInvoice} />
      <AuthRoute path="/app/bank_details" role={role} roles={["SUBCONTRACT"]} component={RecCoinWidrawPage} />
      <AuthRoute path="/app/vendor_raised_invoice" role={role} roles={["SUBCONTRACT"]} component={RecCoinHistory} />
      <AuthRoute path="/app/vendor_candidates" role={role} roles={["SUBCONTRACT"]} component={vendorCandidates} />
      <AuthRoute path="/app/vendor_requirements" role={role} roles={["SUBCONTRACT"]} component={vendorRequirements} />
      <AuthRoute path="/app/vendor_candidates_new" role={role} roles={["SUBCONTRACT"]} component={vendorNew} />
      <AuthRoute path="/app/vendor_candidates_stc" role={role} roles={["SUBCONTRACT"]} component={vendorSTC} />
      <AuthRoute path="/app/vendor_candidates_schedule_interview" role={role} roles={["SUBCONTRACT"]} component={vendorScheduleInterview} />
      <AuthRoute path="/app/vendor_candidates_interview_scheduled" role={role} roles={["SUBCONTRACT"]} component={vendorInterviewScheduled} />
      <AuthRoute path="/app/vendor_candidates_fis" role={role} roles={["SUBCONTRACT"]} component={vendorFinalInterviewScheduled} />
      <AuthRoute path="/app/vendor_candidates_fic" role={role} roles={["SUBCONTRACT"]} component={vendorFinalInterviewCompleted} />
      <AuthRoute path="/app/vendor_candidates_document_collected" role={role} roles={["SUBCONTRACT"]} component={vendorDocumentColleted} />
      <AuthRoute path="/app/vendor_candidates_salary_breakup_shared" role={role} roles={["SUBCONTRACT"]} component={vendorSalaryBreakup} />
      <AuthRoute path="/app/vendor_candidates_offered" role={role} roles={["SUBCONTRACT"]} component={vendorOffered} />
      <AuthRoute path="/app/vendor_candidates_joined" role={role} roles={["SUBCONTRACT"]} component={vendorJoined} />
      <AuthRoute path="/app/vendor_candidates_offer_declined" role={role} roles={["SUBCONTRACT"]} component={vendorOfferedDeclined} />
      <AuthRoute path="/app/vendor_candidates_yet_to_join" role={role} roles={["SUBCONTRACT"]} component={vendorYetToJoin} />
    </Switch>
  );
};

export default VendorRoutes;
